<template>
  <div>
    <el-form
      v-if="planForm"
      ref="formRef"
      :validate-on-rule-change="false"
      :model="planForm"
      :rules="getPlanFormRules.call({ planForm, projectForm })"
      :label-width="labelWidth"
    >
      <template v-if="standardEdit">
        <Divider title="计划与素材信息"></Divider>

        <el-form-item label="AIGC动态创意">
          <el-switch
            v-model="planForm.aigc_dynamic_creative_switch"
            :active-value="DYNAMIC_CREATIVE_SWITCH.ON"
            :inactive-value="DYNAMIC_CREATIVE_SWITCH.OFF"
          ></el-switch>
        </el-form-item>

        <slot name="creatives"></slot>
        <slot name="titles" :planForm="planForm"></slot>

        <el-form-item label="评论" prop="is_comment_disable">
          <el-switch v-model="planForm.is_comment_disable" active-value="ON" inactive-value="OFF"></el-switch>
        </el-form-item>

        <el-form-item label="计划类别" prop="yuntu_category_id">
          <div style="display: flex">
            <el-cascader
              v-model="planForm.yuntu_category_id"
              :append-to-body="false"
              ref="brandCategoryRef"
              @change="onBrandCategoryChange"
              filterable
              placeholder="请选择"
              style="width: 100%"
              :options="brandCategory"
              :props="{ checkStrictly: true, value: 'id', label: 'lable' }"
              clearable
            ></el-cascader>
            <el-button v-if="!isEmptyObj(planForm.yuntu_category_id)" type="text" @click="planForm.yuntu_category_id = []">
              清空
            </el-button>
          </div>
        </el-form-item>

        <el-form-item label="品牌名称" prop="cdp_brand_id">
          <div style="display: flex">
            <el-select
              v-model="planForm.cdp_brand_id"
              @change="onCdpBrandChange"
              filterable
              clearable
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="brand in brandOptions"
                :key="String(brand.cdp_brand_id)"
                :label="brand.cdp_brand_name"
                :value="brand.cdp_brand_id"
              ></el-option>
            </el-select>
            <el-button type="text" v-if="!isEmptyObj(planForm.cdp_brand_id)" @click="clearCdpBrand">清空</el-button>
          </div>
        </el-form-item>
      </template>

      <template v-else>
        <Divider title="计划基础信息"></Divider>
        <el-form-item label="计划名称" prop="plan_name">
          <p>与项目名称相同</p>
        </el-form-item>

        <el-form-item label="推广身份" prop="awemeIdentity">
          <el-radio-group v-model="planForm.awemeIdentity" @change="onAwemeIdentityChange">
            <el-radio-button ghost :disabled="isRelatedStarTask || isLive" :label="AMEME_TYPE.ACCOUNT"> 账号信息 </el-radio-button>
            <el-radio-button ghost :disabled="isRelatedStarTask" :label="AMEME_TYPE.DOUYIN"> 抖音号 </el-radio-button>
            <el-radio-button v-if="!isV3" ghost :disabled="isLive" :label="AMEME_TYPE.AWEME_VIDEO"> 达人视频 </el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抖音号" prop="aweme_id" v-if="planForm.awemeIdentity === AMEME_TYPE.DOUYIN">
          <el-select @change="douyinAccountChange" v-model="planForm.aweme_id" filterable style="width: 320px">
            <el-option v-for="ac in douyinAccountList" :key="ac.aweme_id" :label="ac.aweme_name" :value="ac.aweme_id">
              <div class="custom-douyin-accounts-option-slot">
                <div class="accounts-name">
                  <div class="name">
                    <el-avatar size="small" :src="ac.aweme_avatar"></el-avatar>
                    <h4>{{ ac.aweme_name }}</h4>
                    <p>ID：{{ ac.aweme_id }}</p>
                  </div>

                  <div class="tag">
                    <el-tag size="mini" v-if="ac.status === 'AUTHORIZING'">直播授权</el-tag>
                    <el-tag size="mini" v-if="ac.status === 'BINDING'">抖音号授权</el-tag>
                  </div>
                </div>
              </div>
            </el-option>
          </el-select>
          <div>
            <el-checkbox v-model="planForm.video_hp_visibility" :false-label="VIDEO_HP_VISIBILITY.OFF" :true-label="VIDEO_HP_VISIBILITY.ON">
              主页作品列表隐藏视频
            </el-checkbox>
          </div>
        </el-form-item>
        <!-- 关联星广联投任务且开启自动优选素材时显示 -->
        <template v-if="planForm.awemeIdentity === AMEME_TYPE.AWEME_VIDEO && isEnableStarTaskAutoMaterialSwitch">
          <el-form-item label="抖音号">
            <el-radio-group disabled v-model="planForm.aweme_setting_type">
              <el-radio-button ghost label="SINGLE"> 指定抖音号 </el-radio-button>
              <el-radio-button ghost label="ALL"> 全部抖音号 </el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="标题">
            <el-radio-group v-model="planForm.original_video_title">
              <el-radio-button ghost label="OFF"> 手动添加 </el-radio-button>
              <el-radio-button ghost label="ON"> 投放原视频标题 </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </template>

        <el-form-item v-if="!isV3" label="素材形式">
          <el-radio-group v-model="planForm.materials_type" :disabled="isModify || isVideoImage">
            <el-radio-button v-for="mStyle in MATERIAL_STYLE_LIST" :key="mStyle.value" ghost :label="mStyle.value">
              {{ mStyle.label }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="isV3" label="AIGC动态创意">
          <el-switch
            v-model="planForm.aigc_dynamic_creative_switch"
            :active-value="DYNAMIC_CREATIVE_SWITCH.ON"
            :inactive-value="DYNAMIC_CREATIVE_SWITCH.OFF"
          ></el-switch>
        </el-form-item>

        <el-form-item v-if="isShowAnchor" label="原生锚点" prop="anchor_related_type">
          <el-radio-group v-model="planForm.anchor_related_type">
            <el-radio-button ghost :label="ANCHOR_RELATED_TYPE.OFF"> 不启用 </el-radio-button>
            <el-radio-button ghost :label="ANCHOR_RELATED_TYPE.AUTO"> 自动生成 </el-radio-button>
            <el-radio-button ghost :label="ANCHOR_RELATED_TYPE.SELECT"> 手动选择 </el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- src/views/create/bytedance/modify.vue 批量复制修改时插入的锚点插槽 -->
        <slot name="anchor" v-if="planForm.anchor_related_type === ANCHOR_RELATED_TYPE.SELECT" :planForm="planForm"></slot>
        <!-- src/views/create/bytedance/modify.vue 批量复制修改时插入的创意插槽 -->
        <slot name="creatives" v-if="isPromotionMaterial"></slot>
        <!--批量复制、修改流程： 开启自动优选素材时且是投放原视频标题时不显示文案 -->
        <slot name="titles" v-if="!isOriginVideoTitle && isPromotionMaterial" :planForm="planForm"></slot>

        <template v-if="isPromotionMaterial">
          <template v-if="showFormFields.text_abstract">
            <el-form-item label="文本摘要" prop="text_abstract_list">
              <el-input
                v-if="planForm.text_abstract_list.length < 10"
                v-model="planForm.text_abstract"
                placeholder="单计划最多10个，长度25-45个字，两个英文字符占1位，空格分隔，回车添加，非必填"
                @keyup.enter.native="onTextAbstractEnterKeyConfirm"
              >
                <template slot="append">
                  <el-button @click="onTextAbstractEnterKeyConfirm" type="text">&ensp;添加（回车键）</el-button>
                </template>
              </el-input>
              <TextItemsPreview
                v-show="planForm.text_abstract_list.length"
                @change="clearFieldValidate(['text_abstract_list'])"
                :items.sync="planForm.text_abstract_list"
              ></TextItemsPreview>
            </el-form-item>
          </template>

          <!-- 小游戏推广时必填 -->
          <el-form-item label="来源" :prop="projectForm.landing_type === LANDING_TYPE.MICRO_GAME ? 'source' : ''">
            <el-input v-model="planForm.source" placeholder="字数限制2~10，英文字符限制4~20"> </el-input>
          </el-form-item>

          <template>
            <el-form-item label="产品名称" prop="app_name">
              <el-input v-model="planForm.app_name" placeholder="请输入产品名称(1-20个字符)"> </el-input>
            </el-form-item>

            <el-form-item label="产品主图" prop="app_image">
              <div class="app-image-uploader">
                <el-avatar
                  @click.native="onShowLogoSeletor"
                  v-if="planForm.app_image.url"
                  shape="square"
                  :size="128"
                  fit="cover"
                  :src="planForm.app_image.url"
                ></el-avatar>
                <i v-else @click="onShowLogoSeletor" class="el-icon-plus app-image-uploader-icon"></i>
              </div>
            </el-form-item>

            <el-form-item label="产品卖点" prop="selling_points_list">
              <el-input
                v-if="planForm.selling_points_list.length < 10"
                v-model="planForm.selling_points"
                placeholder="最多10个标签，每个12-18个字符，1个中文等于2个字符，空格分隔，回车添加"
                @keyup.enter.native="onSellingPointsEnterKeyConfirm"
              >
                <template slot="append">
                  <el-button @click="onSellingPointsEnterKeyConfirm" type="text">&ensp;添加（回车键）</el-button>
                </template>
              </el-input>

              <TextItemsPreview
                @change="clearFieldValidate(['selling_points_list'])"
                :items.sync="planForm.selling_points_list"
              ></TextItemsPreview>
            </el-form-item>
          </template>
        </template>

        <slot name="landing-pages" :planForm="planForm" v-if="isEnableLandingPages"></slot>
        <template v-if="isPromotionMaterial">
          <el-form-item v-if="showFormFields.action_buttons" label="行动号召" prop="call_to_action_buttons_list">
            <el-input
              v-if="planForm.call_to_action_buttons_list.length < 10"
              v-model="planForm.call_to_action_buttons"
              placeholder="最多10个标签，每个4-12个字符，1个中文等于2个字符，空格分隔，回车添加"
              @keyup.enter.native="onActionButtonsEnterKeyConfirm"
            >
              <template slot="append">
                <el-button @click="onActionButtonsEnterKeyConfirm" type="text">&ensp;添加（回车键）</el-button>
              </template>
            </el-input>
            <TextItemsPreview
              @change="clearFieldValidate(['call_to_action_buttons_list'])"
              :items.sync="planForm.call_to_action_buttons_list"
            ></TextItemsPreview>
            <div v-if="!isV3">
              <el-switch
                v-model="planForm.intelligent_generation"
                :active-value="INTELLIGENT_GENERATION_SWITCH.ON"
                :inactive-value="INTELLIGENT_GENERATION_SWITCH.OFF"
              ></el-switch>
              <span class="tips">&ensp;开启智能生成行动号召</span>
            </div>
          </el-form-item>

          <template v-if="showFormFields.comment">
            <el-form-item label="评论" prop="is_comment_disable">
              <el-switch v-model="planForm.is_comment_disable" active-value="ON" inactive-value="OFF"></el-switch>
            </el-form-item>
            <el-form-item v-if="!isV3" label="客户端下载视频" prop="ad_download_status">
              <el-switch v-model="planForm.ad_download_status" active-value="ON" inactive-value="OFF"></el-switch>
            </el-form-item>
          </template>
        </template>

        <el-form-item v-if="showFormFields.brand_category" label="计划类别" prop="yuntu_category_id">
          <div style="display: flex">
            <el-cascader
              v-model="planForm.yuntu_category_id"
              :append-to-body="false"
              ref="brandCategoryRef"
              @change="onBrandCategoryChange"
              filterable
              placeholder="请选择"
              style="width: 100%"
              :options="brandCategory"
              :props="{ checkStrictly: true, value: 'id', label: 'lable' }"
              clearable
            ></el-cascader>
            <el-button v-if="!isEmptyObj(planForm.yuntu_category_id)" type="text" @click="planForm.yuntu_category_id = []">清空</el-button>
          </div>
        </el-form-item>
        <el-form-item v-if="showFormFields.brand_info" label="品牌名称" prop="cdp_brand_id">
          <div style="display: flex">
            <el-select
              v-model="planForm.cdp_brand_id"
              @change="onCdpBrandChange"
              filterable
              clearable
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option v-for="brand in brandInfo" :key="brand.cdp_brand_id" :label="brand.cdp_brand_name" :value="brand.cdp_brand_id">
              </el-option>
            </el-select>
            <el-button type="text" v-if="!isEmptyObj(planForm.cdp_brand_id)" @click="clearCdpBrand">清空</el-button>
          </div>
        </el-form-item>

        <!-- 搜索广告显示动态创意，dynamic_creative_switch =ON时，不传入advanced_dc_settings参数表示默认开启2个优化项 -->
        <el-form-item v-if="!isV3 && showFormFields.dynamic_creative" label="动态创意" prop="advanced_dc_settings">
          <el-radio-group v-model="planForm.dynamic_creative_switch">
            <el-radio-button ghost :label="DYNAMIC_CREATIVE_SWITCH.OFF">不开启</el-radio-button>
            <el-radio-button ghost :label="DYNAMIC_CREATIVE_SWITCH.ON">开启</el-radio-button>
          </el-radio-group>

          <template v-if="planForm.dynamic_creative_switch === DYNAMIC_CREATIVE_SWITCH.ON">
            <el-checkbox-group v-model="planForm.advanced_dc_settings">
              <el-checkbox label="OPTIMIZE_SEARCH_RESULTS_PAGE">优化视频、图片、标题等搜索结果页内容</el-checkbox>
              <el-checkbox label="OPTIMIZE_LANDING_PAGE">优化落地页</el-checkbox>
            </el-checkbox-group>
          </template>
        </el-form-item>

        <Divider title="计划预算与出价"></Divider>
        <el-form-item>
          <el-tag type="info">
            <span>
              <span>优化目标：</span>
              <strong>
                {{ EXTERNAL_ACTION_LIST.find((item) => item.value === projectForm.delivery_setting.optimize_goal.external_action).label }}
              </strong>
            </span>
            <span>
              <span>&emsp;深度优化方式：</span>
              <strong>
                {{ DEEP_BID_TYPE_LIST.find((item) => item.value === projectForm.delivery_setting.optimize_goal.deep_bid_type).label }}
              </strong>
            </span>
            <span v-if="projectForm.delivery_setting.optimize_goal.deep_bid_type === DEEP_BID_TYPE.ROI_COEFFICIENT">
              <span>&emsp;深度优化目标：</span>
              <strong>
                {{
                  DEEP_EXTERNAL_ACTION_LIST.find((item) => item.value === projectForm.delivery_setting.optimize_goal.deep_external_action)
                    .label
                }}
              </strong>
            </span>
          </el-tag>
        </el-form-item>

        <template v-if="isSearch">
          <!-- 广告类型：搜索广告 -->

          <!-- 极速智投：同项目预算，无需设置 -->
          <el-form-item v-if="isDuration" label="预算">
            <span>同项目预算</span>
          </el-form-item>

          <!-- 常规投放：自行设置预算 -->
          <el-form-item v-else label="预算" prop="budget">
            <el-input v-model="planForm.budget" style="width: 320px" placeholder="300 ~ 999999.99元"></el-input>
          </el-form-item>
        </template>

        <template v-else>
          <!-- 广告类型：通投广告 -->
          <!-- 手动投放且不启用cbo时，显示预算 -->
          <el-form-item label="预算" prop="budget" v-if="adBudgetVisible">
            <el-input v-model="planForm.budget" style="width: 320px" placeholder="300 ~ 999999.99元"></el-input>
          </el-form-item>
        </template>

        <!-- 手动投放模式下、非最大转化，显示广告出价设置 -->
        <template v-if="adBidVisible">
          <!-- 广告类型：搜索广告 -->
          <el-form-item v-if="isSearch" label="目标出价">同项目出价</el-form-item>
          <!-- 广告类型：通投广告 -->
          <el-form-item v-if="isAll" label="目标出价" prop="cpa_bid">
            <el-radio-group v-model="planForm.bid_type">
              <el-radio-button ghost :label="BID_VALUE_TYPE.FIXED"> 固定出价 </el-radio-button>
              <el-radio-button ghost :label="BID_VALUE_TYPE.RANGE"> 随机区间出价 </el-radio-button>
            </el-radio-group>
            <div style="margin-top: 10px">
              <el-input
                v-if="planForm.bid_type === BID_VALUE_TYPE.FIXED"
                v-model="planForm.cpa_bid"
                style="width: 320px"
                placeholder="0.1 ~ 10000元"
              ></el-input>
              <InputRange v-else v-model="planForm.bid_num_range" placeholder="金额"> </InputRange>
            </div>
          </el-form-item>
          <!-- 广告类型：搜索广告 -->
          <el-form-item label="ROI系数" v-if="isSearch && adDeepBidVisible"> 同项目ROI系数 </el-form-item>

          <el-form-item v-if="isAll && adDeepBidVisible" label="ROI系数" prop="roi_goal">
            <el-radio-group v-model="planForm.roi_bid_type">
              <el-radio-button ghost :label="BID_VALUE_TYPE.FIXED"> 固定出价 </el-radio-button>
              <el-radio-button ghost :label="BID_VALUE_TYPE.RANGE"> 随机区间出价 </el-radio-button>
            </el-radio-group>
            <div style="margin-top: 10px">
              <el-input
                v-if="planForm.roi_bid_type === BID_VALUE_TYPE.FIXED"
                v-model="planForm.roi_goal"
                style="width: 320px"
                placeholder="0.0001 ~ 5"
              ></el-input>
              <InputRange v-else v-model="planForm.roi_bid_num_range"> </InputRange>
            </div>
          </el-form-item>
        </template>
      </template>
    </el-form>

    <AssetsSelectorModal
      :visible.sync="showSelectorModal"
      v-bind="{ ...selectorProps }"
      @close="onSelectorClose"
      @confirm="onSelectorConfirm"
    >
      <template v-slot:assetType="{ getData }">
        <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]"> LOGO </el-radio>
      </template>
    </AssetsSelectorModal>
  </div>
</template>

<script setup>
import { ref, unref, computed, toRef, watch, inject } from 'vue'
import Divider from '../layout/title-divider.vue'
import TextItemsPreview from '../layout/text-items-preview.vue'
import InputRange from '@/views/edit/kuaishou/components/input-range/index.vue'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import AssetsSelectorModal, { makeSelectorForm } from '@/components/material-selector/index.js'
import { useMaterialSelector, useFormTextHanlder } from './usePlanForm.js'
import { useOptimizeGoalRelative } from '../../hooks/useOptimizeGoal.js'
import { useProjectParamStates, usePageStates } from '../../hooks/useCommonComputeds.js'

import { getPlanFormRules } from '../../rules/index.js'
import { PLATFORM } from '@/common/js/constants'
import { isEmptyObj } from '@/common/js/utils'
import {
  AMEME_TYPE,
  LANDING_TYPE,
  ANCHOR_RELATED_TYPE,
  BID_VALUE_TYPE,
  EXTERNAL_ACTION_LIST,
  DEEP_EXTERNAL_ACTION_LIST,
  DEEP_BID_TYPE,
  DEEP_BID_TYPE_LIST,
  VIDEO_HP_VISIBILITY,
  INTELLIGENT_GENERATION_SWITCH,
  DYNAMIC_CREATIVE_SWITCH,
  MARKETING_GOAL,
  MATERIAL_STYLE_LIST,
  MATERIAL_STYLE
} from '../../consts/index.js'

import { iesAccountSearch } from '@/api/toutiao.model'
import { getBrandCategoryInfo, getBrandList } from '@/api/toutiao.local.model.js'

// eslint-disable-next-line
const props = defineProps({
  projectForm: Object,
  // rules: Object,
  adAccount: Object,
  labelWidth: {
    type: String,
    default: '120px'
  },
  standardEdit: {
    type: Boolean,
    default: false
  }
})

const formRef = ref(null)

const planForm = ref(null)
const projectForm = toRef(props, 'projectForm')
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })

const douyinAccountList = ref([])
const brandCategory = ref([])
const brandInfo = ref([])
const brandCategoryRef = ref(null)
const standardEdit = computed(() => props.standardEdit)
const brandOptions = computed(() => {
  const options = [...brandInfo.value]
  const currentId = planForm.value?.cdp_brand_id
  if (currentId && !options.some((brand) => String(brand.cdp_brand_id) === String(currentId))) {
    options.unshift({
      cdp_brand_id: currentId,
      brand_name_id: planForm.value.brand_name_id,
      cdp_brand_name: planForm.value.cdp_brand_text || `历史品牌（${String(currentId)}）`
    })
  }
  return options
})
const { isReservation } = useProjectParamStates(projectForm)
const { isModify } = usePageStates()

// 项目是否是直播营销场景
const isLive = computed(() => projectForm.value.marketing_goal === MARKETING_GOAL.LIVE)
const isVideoImage = computed(() => projectForm.value.marketing_goal === MARKETING_GOAL.VIDEO_AND_IMAGE)
const isPromotionMaterial = computed(() => planForm.value.materials_type === MATERIAL_STYLE.PROMOTION_MATERIALS)
// 项目是否关联星广联投任务
const isRelatedStarTask = computed(() => !!projectForm.value.star_task?.star_task_id)
// 关联星广联投任务且开启自动优选素材
const isEnableStarTaskAutoMaterialSwitch = computed(
  () => !isV3.value && isRelatedStarTask.value && projectForm.value.star_auto_material_addition_switch === 'ON'
)

const isOriginVideoTitle = computed(() => {
  return isEnableStarTaskAutoMaterialSwitch.value && planForm.value.original_video_title === 'ON'
})
const isEnableLandingPages = computed(() => {
  // 预约下载时都显示；
  if (isReservation.value) return true
  // 落地页只显示Android、小程序、鸿蒙
  return [PLATFORM.ANDROID, PLATFORM.MINI_PROGRAM, PLATFORM.HARMONY].includes(projectForm.value.ch_platform_id)
})

const { showSelectorModal, selectorProps, onShowLogoSeletor, onSelectorClose } = useMaterialSelector()
const { onActionButtonsEnterKeyConfirm, onSellingPointsEnterKeyConfirm, onTextAbstractEnterKeyConfirm } = useFormTextHanlder(planForm)
const { isAll, isSearch, isDuration, isBlueFlowEnable, adDeepBidVisible, adBudgetVisible, adBidVisible } =
  useOptimizeGoalRelative(projectForm)

/**
 * @description:
投放类型  项目类型 智能拓流         动态创意         品牌名称（新增） 广告类别（新增）   广告评论    行动号召                      产品相关信息               原生锚点         素材类型                          文本摘要                                   落地页          广告-关键词设置         广告预算            广告出价
搜索广告 常规投放  可设置开启和关闭  可设置开启和关闭   下拉选择        下拉选择         开启和关闭  最多10个，增加开启智能生成的开关  产品主图、产品名称、产品卖点 不启用/自动生成    视频、图片、图文（同原来普通广告一样） 最多设置10个，长度25-45个字，两个英文字符占1位 可设置10个落地页  弹窗批量手动设置或者选择 自行设置预算         同项目出价，无需设置
搜索广告 极速智投  不能关闭智能拓流   ——              ——            ——              ——         ——                           ——                        ——            视频、图片、图文（同原来普通广告一样） 最多设置10个，长度25-45个字，两个英文字符占1位 可设置10个落地页  弹窗批量手动设置或者选择  同项目预算，无需设置  同项目出价，无需设置
非搜索广告 ——     ——             新增             下拉选择        拉选择           开启和关闭  最多10个，增加开启智能生成的开关  产品主图、产品名称、产品卖点  不启用/自动生成   视频、图片、图文（同原来普通广告一样） ——                                       可设置10个落地页  ——                   原来逻辑不变         原来逻辑不变
 * @return {*}
 */
const showFormFields = computed(() => {
  return {
    // 智能拓流
    auto_extend_traffic: isSearch.value,
    // 动态创意
    dynamic_creative: isSearch.value && !isDuration.value,
    // 品牌名称
    brand_info: !isDuration.value,
    // 广告类别
    brand_category: isAll.value,
    // 广告评论
    comment: !isDuration.value,
    // 行动号召
    action_buttons: !isDuration.value,
    // 产品相关信息
    selling_points: !isDuration.value,
    // 原生锚点
    anchor_related_type: !isDuration.value,
    // 文本摘要
    text_abstract: isSearch.value,
    // 关键词
    keywords: isSearch.value
  }
})

const isShowAnchor = computed(() => {
  // 直播场景不显示
  if (isLive.value) return false
  return showFormFields.value.anchor_related_type && [AMEME_TYPE.AWEME_VIDEO, AMEME_TYPE.DOUYIN].includes(planForm.value.awemeIdentity)
})

watch(
  () => props.adAccount.id,
  () => {
    getDouyinAccountList()
    getBrandCategory()
  }
)

/**
 * @description: 获取抖音账号列表
 */
const getDouyinAccountList = () => {
  const ad_account_id = props.adAccount.id
  iesAccountSearch({ ad_account_id }).then((data) => {
    douyinAccountList.value = data?.length
      ? data.map((i) => {
        return {
          ...i,
          aweme_id: i.aweme_id || i.ies_id,
          aweme_name: i.aweme_name || i.ies_user_name
        }
      })
      : []
  })
}

/**
 * @description: 获取关联云图的广告主账户信息
 * @return {*}
 */
const getBrandCategory = async () => {
  const ad_account_id = props.adAccount.id
  const categoryData = await getBrandCategoryInfo({ ad_account_id })
  brandCategory.value = categoryData?.brand_category_info || []

  if (isV3.value) {
    brandInfo.value = (await getBrandList({ ad_account_id })) || []
    restoreHistoricalBrandCategoryPath()
    return
  }

  brandInfo.value = categoryData?.brand_info_data || []
}

const onBrandCategoryChange = () => {
  const [node] = brandCategoryRef.value.getCheckedNodes()
  if (node) {
    planForm.value.brand_category_paths = node.pathLabels.join('/')
  }
}

const onCdpBrandChange = (value) => {
  const options = props.standardEdit ? brandOptions.value : brandInfo.value
  const brand = options.find((item) => String(item.cdp_brand_id) === String(value))
  planForm.value.cdp_brand_text = brand?.cdp_brand_name || ''
  if (isV3.value) planForm.value.brand_name_id = brand?.brand_name_id || ''
}

function restoreHistoricalBrandCategoryPath() {
  const currentPath = planForm.value?.yuntu_category_id || []
  if (!props.standardEdit || currentPath.length !== 1) return
  const path = findCategoryPath(brandCategory.value, String(currentPath[0]))
  if (path.length) {
    planForm.value.yuntu_category_id = path
    return
  }
  brandCategory.value.unshift({
    id: currentPath[0],
    lable: `历史类别（${String(currentPath[0])}）`,
    children: []
  })
}

function findCategoryPath(nodes, targetId, parentPath = []) {
  for (const node of nodes) {
    const path = [...parentPath, node.id]
    if (String(node.id) === targetId) return path
    const childPath = findCategoryPath(node.children || [], targetId, path)
    if (childPath.length) return childPath
  }
  return []
}

const clearCdpBrand = () => {
  planForm.value.cdp_brand_id = ''
  onCdpBrandChange('')
}

if (props.standardEdit || showFormFields.value.brand_category || showFormFields.value.brand_info) {
  getBrandCategory()
}

/**
 * @description: 蓝海流量投放关键词下拉列表获取
 * @return {*}
 */
const blueFlowKeywordList = computed(() => {
  const { seleted_blue_flow_package } = projectForm.value
  return seleted_blue_flow_package?.blue_flow_keyword || []
})

/**
 * @description: 选择主图素材
 * @param {*} app_image
 */
const onSelectorConfirm = ([app_image]) => {
  planForm.value.app_image = app_image
}

const douyinAccountChange = (value) => {
  planForm.value.aweme_info = douyinAccountList.value.find((item) => item.aweme_id === value) || {}
}
/**
 * @description: 切换推广身份
 * @param {*} e
 */
function onAwemeIdentityChange(e) {
  if (e === AMEME_TYPE.DOUYIN) {
    getDouyinAccountList()
  }
}

function clearFieldValidate(props) {
  formRef.value?.clearValidate(props)
}

// eslint-disable-next-line
defineExpose({
  setForm: (form) => {
    planForm.value = form
    onAwemeIdentityChange(form.awemeIdentity)
    restoreHistoricalBrandCategoryPath()
  },
  getForm: () => unref(planForm),
  validate: () => formRef.value.validate()
})
</script>

<style lang="scss" scoped>
.el-form {
  .app-image-uploader {
    &-icon {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
  }
  .tips {
    color: #7d7d7d;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.custom-douyin-accounts-option-slot {
  display: flex;
  align-items: center;
  .accounts-name {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .name {
      display: flex;
      align-items: center;
      font-size: 12px;
    }
    h4 {
      margin-left: 10px;
    }
    p {
      margin-left: 20px;
    }

    .tag {
      margin-left: 10px;
    }
  }
}
</style>
